import { BaseType } from '../../base/base-type';

export class DesignatedUnitLessThanFullTimeParticipationType extends BaseType {}
